'use client'

import { Builder } from '@builder.io/react'

import { NutritionalFactsDefaults } from '@src/components/NutritionalFacts/NutritionalFacts.defaults'

import { NutritionalFacts } from './NutritionalFacts'

Builder.registerComponent(NutritionalFacts, {
  name: 'NutritionalFacts',
  inputs: [
    {
      name: 'heading',
      type: 'richText',
      defaultValue: NutritionalFactsDefaults.heading,
    },
    {
      name: 'previewAllItems',
      type: 'boolean',
      defaultValue: NutritionalFactsDefaults.previewAllItems,
    },
    {
      name: 'skipWrapper',
      friendlyName: 'Hide border',
      type: 'boolean',
      defaultValue: NutritionalFactsDefaults.skipWrapper,
    },
    {
      name: 'singleColumn',
      type: 'boolean',
      defaultValue: NutritionalFactsDefaults.singleColumn,
    },
    {
      name: 'items',
      friendlyName: 'Nutritional sheets',
      type: 'list',
      defaultValue: NutritionalFactsDefaults.items,
      subFields: [
        {
          name: 'flavorName',
          type: 'text',
          defaultValue: NutritionalFactsDefaults.items[0]?.flavorName,
        },
        {
          name: 'blocksSubheading',
          type: 'blocks',
          hideFromUI: true,
          defaultValue: NutritionalFactsDefaults.items[0]?.blocksSubheading,
        },
        {
          name: 'blocksRight',
          type: 'blocks',
          hideFromUI: true,
          defaultValue: NutritionalFactsDefaults.items[0]?.blocksRight,
        },
        {
          name: 'blocksTop',
          type: 'blocks',
          hideFromUI: true,
          defaultValue: NutritionalFactsDefaults.items[0]?.blocksTop,
        },
        {
          name: 'blocksBottom',
          type: 'blocks',
          hideFromUI: true,
          defaultValue: NutritionalFactsDefaults.items[0]?.blocksBottom,
        },
        {
          name: 'tableItems',
          type: 'list',
          defaultValue: NutritionalFactsDefaults.items[0]?.tableItems,
          subFields: [
            {
              name: 'cellType',
              type: 'string',
              enum: ['header', 'body'],
            },
            {
              name: 'content',
              type: 'blocks',
              hideFromUI: true,
            },
            {
              name: 'columns',
              type: 'list',
              subFields: [
                {
                  name: 'content',
                  type: 'blocks',
                  hideFromUI: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
})
